import React, { useState, useEffect, useCallback } from "react";
import "./MoviesPage.css";
import "./App.css";

// Movie list using the actual image filenames from the public/movies directory
const movies = [
  {
    title: "The Great Dictator",
    year: "1940",
    country: "Charlie Chaplin",
    description:
      "A satirical comedy in which Charlie Chaplin plays both a ruthless dictator and a persecuted Jewish barber, delivering a powerful message against fascism.",
    image: process.env.PUBLIC_URL + "/movies-images/The-Great-Dictator-1.jpg",
    alt: "The Great Dictator Poster",
    imdb: "https://www.imdb.com/title/tt0032553/",
  },
  {
    title: "Casablanca",
    year: "1942",
    country: "United States",
    description:
      "A cynical American expatriate struggles to decide whether or not he should help his former lover and her fugitive husband escape French Morocco.",
    image: process.env.PUBLIC_URL + "/movies-images/casablanca-3.avif",
    alt: "Casablanca Poster 3",
    imdb: "https://www.imdb.com/title/tt0034583/",
  },
  {
    title: "Sabrina",
    year: "1954",
    country: "United States",
    description:
      "A chauffeur's daughter returns from Paris and finds herself in a love triangle with the wealthy sons of her father's employer.",
    image: process.env.PUBLIC_URL + "/movies-images/sabrina-1.jpg",
    alt: "Sabrina Poster",
    imdb: "https://www.imdb.com/title/tt0047437/",
  },
  {
    title: "Breathless",
    year: "1960",
    country: "France",
    description:
      "A small-time thief steals a car and impulsively murders a policeman. Wanted by the authorities, he reunites with an American journalism student and attempts to persuade her to run away with him to Italy.",
    image: process.env.PUBLIC_URL + "/movies-images/breathless-1.jpg",
    alt: "Breathless Poster",
    imdb: "https://www.imdb.com/title/tt0053472/",
  },
  {
    title: "The Apartment",
    year: "1960",
    country: "United States",
    description:
      "A Manhattan insurance clerk lets his bosses use his apartment for their extramarital affairs, but complications arise when he falls for the company's elevator operator.",
    image: process.env.PUBLIC_URL + "/movies-images/the-apartment-1.jpg",
    alt: "The Apartment Poster",
    imdb: "https://www.imdb.com/title/tt0053604/",
  },
  {
    title: "Breakfast at Tiffany's",
    year: "1961",
    country: "United States",
    description:
      "A young New York socialite becomes interested in a young man who has moved into her apartment building.",
    image:
      process.env.PUBLIC_URL + "/movies-images/breakfast-at-tiffanys-1.webp",
    alt: "Breakfast at Tiffany's Poster",
    imdb: "https://www.imdb.com/title/tt0054698/",
  },
  {
    title: "The Rocky Horror Picture Show",
    year: "1975",
    country: "United Kingdom",
    description:
      "A newly engaged couple have a breakdown in an isolated area and must seek shelter at the bizarre residence of Dr. Frank-N-Furter.",
    image:
      process.env.PUBLIC_URL +
      "/movies-images/the-rocky-horror-picture-show-1.jpg",
    alt: "The Rocky Horror Picture Show Poster",
    imdb: "https://www.imdb.com/title/tt0073629/",
  },
  {
    title: "Alien",
    year: "1979",
    country: "United Kingdom",
    description:
      "The crew of a commercial spacecraft encounters a deadly extraterrestrial after investigating a mysterious transmission from an alien planet.",
    image: process.env.PUBLIC_URL + "/movies-images/alien-1.webp",
    alt: "Alien Poster",
    imdb: "https://www.imdb.com/title/tt0078748/",
  },
  {
    title: "The Blues Brothers",
    year: "1980",
    country: "United States",
    description:
      "Jake and Elwood Blues set out on a 'mission from God' to save their childhood orphanage, encountering a wild series of musical performances, car chases, and hilarious antics along the way.",
    image: process.env.PUBLIC_URL + "/movies-images/the-blues-brothers.jpg",
    alt: "The Blues Brothers Poster",
    imdb: "https://www.imdb.com/title/tt0080455/",
  },
  {
    title: "WarGames",
    year: "1983",
    country: "United States",
    description:
      "A young computer whiz kid accidentally hacks into a U.S. military supercomputer, nearly starting World War III when the system begins to simulate a nuclear war.",
    image: process.env.PUBLIC_URL + "/movies-images/War-Games-1.jpg",
    alt: "WarGames Poster",
    imdb: "https://www.imdb.com/title/tt0086567/",
  },
  {
    title: "Akira",
    year: "1988",
    country: "Japan",
    description:
      "A secret military project endangers Neo-Tokyo when it turns a biker gang member into a rampaging psychic psychopath that only two teenagers and a group of psychics can stop.",
    image: process.env.PUBLIC_URL + "/movies-images/akira-1.webp",
    alt: "Akira Poster",
    imdb: "https://www.imdb.com/title/tt0094625/",
  },
  {
    title: "The Naked Gun: From the Files of Police Squad!",
    year: "1988",
    country: "United States",
    description:
      "In this slapstick comedy, bumbling police detective Frank Drebin tries to foil an attempt to assassinate Queen Elizabeth II, resulting in a series of outrageous and hilarious mishaps.",
    image: process.env.PUBLIC_URL + "/movies-images/the-naked-gun-1.jpg",
    alt: "The Naked Gun: From the Files of Police Squad! Poster",
    imdb: "https://www.imdb.com/title/tt0095705/",
  },
  {
    title: "Grave of the Fireflies",
    year: "1989",
    country: "Japan",
    description:
      "A devastating meditation on the human cost of war, focusing on two siblings struggling to survive in Japan during World War II.",
    image:
      process.env.PUBLIC_URL + "/movies-images/grave-of-the-fireflies-1.avif",
    alt: "Grave of the Fireflies Poster",
    imdb: "https://www.imdb.com/title/tt0095327/",
  },
  {
    title: "Schindler's List",
    year: "1993",
    country: "United States",
    description:
      "In German-occupied Poland during World War II, industrialist Oskar Schindler gradually becomes concerned for his Jewish workforce after witnessing their persecution by the Nazis.",
    image: process.env.PUBLIC_URL + "/movies-images/schindler-list-2.webp",
    alt: "Schindler's List Poster 2",
    imdb: "https://www.imdb.com/title/tt0108052/",
  },
  {
    title: "Batman: Mask of the Phantasm",
    year: "1993",
    country: "United States",
    description:
      "Batman faces a mysterious vigilante known as the Phantasm, who is linked to his past and a series of mob murders in Gotham City.",
    image:
      process.env.PUBLIC_URL +
      "/movies-images/Batman-Mask-of-1the-Phantasm-1.jpg",
    alt: "Batman: Mask of the Phantasm Poster",
    imdb: "https://www.imdb.com/title/tt0106364/",
  },
  {
    title: "Falling Down",
    year: "1993",
    country: "United States",
    description:
      "An ordinary man, frustrated with the various flaws he sees in society, goes on a violent rampage across Los Angeles after a series of personal and societal setbacks.",
    image: process.env.PUBLIC_URL + "/movies-images/Falling-Down-1.jpg",
    alt: "Falling Down Poster",
    imdb: "https://www.imdb.com/title/tt0106856/",
  },
  {
    title: "Léon",
    year: "1994",
    country: "France",
    description:
      "A professional assassin becomes an unlikely guardian to a young girl after her family is murdered, forming a unique bond as he teaches her his trade.",
    image: process.env.PUBLIC_URL + "/movies-images/leon-1.jpg",
    alt: "Léon Poster",
    imdb: "https://www.imdb.com/title/tt0110413/",
  },
  {
    title: "Chungking Express",
    year: "1994",
    country: "Hong Kong",
    description:
      "Two melancholy Hong Kong policemen fall in love: one with a mysterious woman on the run, the other with a quirky snack bar worker.",
    image: process.env.PUBLIC_URL + "/movies-images/Chungking-Express-1.jpg",
    alt: "Chungking Express Poster",
    imdb: "https://www.imdb.com/title/tt0109424/",
  },
  {
    title: "The Mask",
    year: "1994",
    country: "United States",
    description:
      "A timid bank clerk discovers a magical mask that transforms him into a mischievous, cartoonish superhero with reality-bending powers.",
    image: process.env.PUBLIC_URL + "/movies-images/the-mask-1.jpg",
    alt: "The Mask Poster",
    imdb: "https://www.imdb.com/title/tt0110475/",
  },
  {
    title: "Pulp Fiction",
    year: "1994",
    country: "United States",
    description:
      "The lives of two mob hitmen, a boxer, a gangster's wife, and a pair of diner bandits intertwine in four tales of violence and redemption.",
    image: process.env.PUBLIC_URL + "/movies-images/pulp-fiction-1.jpg",
    alt: "Pulp Fiction Poster",
    imdb: "https://www.imdb.com/title/tt0110912/",
  },
  {
    title: "Ghost in the Shell",
    year: "1995",
    country: "Japan",
    description:
      "A female cyborg cop searches for a mysterious hacker in a futuristic Japanese city, exploring themes of consciousness, identity, and technology.",
    image: process.env.PUBLIC_URL + "/movies-images/Ghost-in-the-Shell-1.jpeg",
    alt: "Ghost in the Shell Poster",
    imdb: "https://www.imdb.com/title/tt0113568/",
  },
  {
    title: "Die Hard with a Vengeance",
    year: "1995",
    country: "United States",
    description:
      "NYPD officer John McClane teams up with a Harlem shop owner to stop a mysterious terrorist who is playing deadly games across New York City.",
    image: process.env.PUBLIC_URL + "/movies-images/Die-Hard-Vengeance-1.png",
    alt: "Die Hard with a Vengeance Poster",
    imdb: "https://www.imdb.com/title/tt0112864/",
  },
  {
    title: "Judge Dredd",
    year: "1995",
    country: "United States",
    description:
      "In a dystopian future where the police act as judge, jury, and executioner, Judge Dredd is framed for a crime he didn't commit and must fight to clear his name and restore justice.",
    image: process.env.PUBLIC_URL + "/movies-images/judge-dredd-1.avif",
    alt: "Judge Dredd Poster",
    imdb: "https://www.imdb.com/title/tt0113492/",
  },
  {
    title: "Neon Genesis Evangelion: The End of Evangelion",
    year: "1997",
    country: "Japan",
    description:
      "A cinematic conclusion to the acclaimed anime series, following Shinji Ikari and the other Eva pilots as they confront the apocalyptic Human Instrumentality Project and the fate of humanity.",
    image:
      process.env.PUBLIC_URL +
      "/movies-images/Neon-Genesis-Evangelion-Ending-2.jpg",
    alt: "Neon Genesis Evangelion: The End of Evangelion Poster",
    imdb: "https://www.imdb.com/title/tt0169858/",
  },
  {
    title: "Hana-bi",
    year: "1997",
    country: "Japan",
    description:
      "A former police officer, struggling with personal tragedy and his wife's terminal illness, becomes involved in a violent world of crime and redemption.",
    image: process.env.PUBLIC_URL + "/movies-images/hana-bi-1.jpg",
    alt: "Hana-bi Poster",
    imdb: "https://www.imdb.com/title/tt0119250/",
  },
  {
    title: "Perfect Blue",
    year: "1997",
    country: "Japan",
    description:
      "Mima, a pop idol turned actress, finds her grip on reality unravelling as she becomes the target of a stalker and is haunted by her past persona in this psychological thriller.",
    image: process.env.PUBLIC_URL + "/movies-images/Perfect-Blue-1.jpg",
    alt: "Perfect Blue Poster",
    imdb: "https://www.imdb.com/title/tt0156887/",
  },
  {
    title: "Taxi",
    year: "1998",
    country: "France",
    description:
      "A police officer exchanges his police car for a taxi to catch a group of German bank robbers.",
    image: process.env.PUBLIC_URL + "/movies-images/taxi-1.jpg",
    alt: "Taxi Poster",
    imdb: "https://www.imdb.com/title/tt0152930/",
  },
  {
    title: "Serpent's Path",
    year: "1998",
    country: "Japan",
    description:
      "A grieving father teams up with a mysterious friend to exact revenge on those responsible for his daughter's murder, leading to a dark and twisting journey of vengeance.",
    image: process.env.PUBLIC_URL + "/movies-images/SerpentsPath-1.jpg",
    alt: "Serpent's Path Poster",
    imdb: "https://www.imdb.com/title/tt0164101/",
  },
  {
    title: "Serial Experiments Lain",
    year: "1998",
    country: "Japan",
    description:
      "After receiving a mysterious email from a classmate who committed suicide, teenage girl Lain is drawn into the surreal world of the Wired—a virtual reality network—as she questions her own identity and the nature of reality.",
    image: process.env.PUBLIC_URL + "/movies-images/Serial-Experiments-Lain-1.png",
    alt: "Serial Experiments Lain Poster",
    imdb: "https://www.imdb.com/title/tt0500092/",
  },
  {
    title: "The Green Mile",
    year: "1999",
    country: "United States",
    description:
      "A gentle giant with a mysterious gift arrives on death row, profoundly affecting the lives of the guards and inmates in this moving supernatural drama.",
    image: process.env.PUBLIC_URL + "/movies-images/The-green-mile-1.webp",
    alt: "The Green Mile Poster",
    imdb: "https://www.imdb.com/title/tt0120689/",
  },
  {
    title: "Eyes Wide Shut",
    year: "1999",
    country: "United States",
    description:
      "After his wife admits to having sexual fantasies about another man, a New York City doctor embarks on a surreal, night-long odyssey of sexual and moral discovery.",
    image: process.env.PUBLIC_URL + "/movies-images/eyes-wide-shut-1.jpg",
    alt: "Eyes Wide Shut Poster",
    imdb: "https://www.imdb.com/title/tt0120663/",
  },
  {
    title: "Hollow Man",
    year: "2000",
    country: "United States",
    description:
      "A brilliant scientist tests an invisibility serum on himself, but the side effects unleash his darker instincts, leading to terror and chaos.",
    image: process.env.PUBLIC_URL + "/movies-images/hollow-man-1.jpg",
    alt: "Hollow Man Poster",
    imdb: "https://www.imdb.com/title/tt0164052/",
  },
  {
    title: "Scary Movie",
    year: "2000",
    country: "United States",
    description:
      "A year after disposing of the body of a man they accidentally killed, two friends discover the murder has been covered up and they are being blackmailed.",
    image: process.env.PUBLIC_URL + "/movies-images/scary-movie-1.jpg",
    alt: "Scary Movie Poster",
    imdb: "https://www.imdb.com/title/tt0175142/",
  },
  {
    title: "Donnie Darko",
    year: "2001",
    country: "United States",
    description:
      "A troubled teenager is plagued by surreal visions and a dark, supernatural force, leading him to question his own sanity.",
    image: process.env.PUBLIC_URL + "/movies-images/donnie-darko-1.jpg",
    alt: "Donnie Darko Poster",
    imdb: "https://www.imdb.com/title/tt0246578/",
  },
  {
    title: "Spirited Away",
    year: "2001",
    country: "Japan",
    description:
      "During her family's move to the suburbs, a sullen 10-year-old girl wanders into a world ruled by gods, witches, and spirits, and where humans are changed into beasts.",
    image: process.env.PUBLIC_URL + "/movies-images/spirited-away-1.avif",
    alt: "Spirited Away Poster",
    imdb: "https://www.imdb.com/title/tt0245429/",
  },

  {
    title: "Cowboy Bebop: The Movie",
    year: "2001",
    country: "Japan",
    description:
      "The crew of the spaceship Bebop pursues a dangerous criminal who plans to launch a deadly biological weapon in this anime film based on the popular series.",
    image: process.env.PUBLIC_URL + "/movies-images/cowboy-bebop-1.jpg",
    alt: "Cowboy Bebop: The Movie Poster",
    imdb: "https://www.imdb.com/title/tt0275277/",
  },
  {
    title: "Zoolander",
    year: "2001",
    country: "United States",
    description:
      "At the height of his career, dimwitted male model Derek Zoolander is brainwashed to assassinate the Prime Minister of Malaysia in this outrageous fashion industry satire.",
    image: process.env.PUBLIC_URL + "/movies-images/zoolander-1.jpg",
    alt: "Zoolander Poster",
    imdb: "https://www.imdb.com/title/tt0196229/",
  },
  {
    title: "The Ring",
    year: "2002",
    country: "United States",
    description:
      "A journalist investigates a mysterious videotape which seems to cause the death of anyone one week to the day after they view it.",
    image: process.env.PUBLIC_URL + "/movies-images/the-ring-1.jpg",
    alt: "The Ring Poster",
    imdb: "https://www.imdb.com/title/tt0298130/",
  },
  {
    title: "Lost in Translation",
    year: "2003",
    country: "United States",
    description:
      "Two lost souls visiting Tokyo -- the young, neglected wife of a photographer and a washed-up movie star shooting a TV commercial -- find an odd connection and a sense of solace in each other.",
    image: process.env.PUBLIC_URL + "/movies-images/lost-in-translation-2.webp",
    alt: "Lost in Translation Poster",
    imdb: "https://www.imdb.com/title/tt0335266/",
  },
  {
    title: "Love Actually",
    year: "2003",
    country: "United Kingdom",
    description:
      "Follows the lives of eight very different couples in dealing with their love lives in various loosely interrelated tales all set during a frantic month before Christmas in London.",
    image: process.env.PUBLIC_URL + "/movies-images/love-actually-1.avif",
    alt: "Love Actually Poster",
    imdb: "https://www.imdb.com/title/tt0314331/",
  },
  {
    title: "Kill Bill: Vol. 1",
    year: "2003",
    country: "United States",
    description:
      "After awakening from a four-year coma, a former assassin known as The Bride embarks on a relentless quest for vengeance against the team of assassins who betrayed her.",
    image: process.env.PUBLIC_URL + "/movies-images/kill-bill-v1-1.jpg",
    alt: "Kill Bill: Vol. 1 Poster",
    imdb: "https://www.imdb.com/title/tt0266697/",
  },
  {
    title: "Shaun of the Dead",
    year: "2004",
    country: "United Kingdom",
    description:
      "A man's uneventful life is disrupted when he finds himself in the midst of a zombie apocalypse, forcing him to step up and save his friends and family.",
    image: process.env.PUBLIC_URL + "/movies-images/Shaun-of-the-Dead-1.jpg",
    alt: "Shaun of the Dead Poster",
    imdb: "https://www.imdb.com/title/tt0365748/",
  },
  {
    title: "Closer",
    year: "2004",
    country: "United States",
    description:
      "The relationships of two couples become complicated and deceitful as they explore the emotional side of infidelity.",
    image: process.env.PUBLIC_URL + "/movies-images/closer-1.jpg",
    alt: "Closer Poster",
    imdb: "https://www.imdb.com/title/tt0376541/",
  },
  {
    title: "Constantine",
    year: "2005",
    country: "United States",
    description:
      "Constantine tells the story of irreverent supernatural detective John Constantine, who has literally been to hell and back.",
    image: process.env.PUBLIC_URL + "/movies-images/constantine-1.jpg",
    alt: "Constantine Poster",
    imdb: "https://www.imdb.com/title/tt0360486/",
  },
  {
    title: "Kiss Kiss Bang Bang",
    year: "2005",
    country: "United States",
    description:
      "A murder mystery brings together a private eye, a struggling actress, and a thief masquerading as an actor in this darkly comedic neo-noir.",
    image: process.env.PUBLIC_URL + "/movies-images/kiss-kiss-bang-bang-1.webp",
    alt: "Kiss Kiss Bang Bang Poster",
    imdb: "https://www.imdb.com/title/tt0373469/",
  },
  {
    title: "Fast & Furious: Tokyo Drift",
    year: "2006",
    country: "United States",
    description:
      "A teenager becomes a major competitor in the world of drift racing after moving in with his father in Tokyo to avoid criminal charges back in the United States.",
    image:
      process.env.PUBLIC_URL +
      "/movies-images/fast-and-furious-tokyo-drive-1.jpg",
    alt: "Fast and Furious Tokyo Drift Poster",
    imdb: "https://www.imdb.com/title/tt0463985/",
  },
  {
    title: "Scary Movie 4",
    year: "2006",
    country: "United States",
    description:
      "The fourth installment of the parody franchise, lampooning horror and pop culture films as Cindy Campbell finds herself facing bizarre supernatural events and an alien invasion.",
    image: process.env.PUBLIC_URL + "/movies-images/scary-movie-4-1.jpg",
    alt: "Scary Movie 4 Poster",
    imdb: "https://www.imdb.com/title/tt0362120/",
  },
  {
    title: "Cars",
    year: "2006",
    country: "United States",
    description:
      "A hotshot race car named Lightning McQueen gets waylaid in Radiator Springs, where he finds the true meaning of friendship and family.",
    image: process.env.PUBLIC_URL + "/movies-images/cars-1.jpg",
    alt: "Cars Poster",
    imdb: "https://www.imdb.com/title/tt0317219/",
  },
  {
    title: "Children of Men",
    year: "2006",
    country: "United Kingdom",
    description:
      "In a bleak future where humans have become infertile, a disillusioned bureaucrat is tasked with protecting a miraculously pregnant woman to save humanity.",
    image: process.env.PUBLIC_URL + "/movies-images/children-of-the-man-1.jpg",
    alt: "Children of Men Poster",
    imdb: "https://www.imdb.com/title/tt0206634/",
  },
  {
    title: "Gran Torino",
    year: "2008",
    country: "United States",
    description:
      "A disgruntled Korean War veteran sets out to reform his neighbor, a young Hmong teenager, who tried to steal his prized 1972 Gran Torino.",
    image: process.env.PUBLIC_URL + "/movies-images/gran-torino-1.jpg",
    alt: "Gran Torino Poster",
    imdb: "https://www.imdb.com/title/tt1205489/",
  },
  {
    title: "WALL-E",
    year: "2008",
    country: "United States",
    description:
      "In the distant future, a small waste-collecting robot inadvertently embarks on a space journey that will ultimately decide the fate of mankind.",
    image: process.env.PUBLIC_URL + "/movies-images/wall-e-1.jpg",
    alt: "WALL-E Poster",
    imdb: "https://www.imdb.com/title/tt0910970/",
  },
  {
    title: "District 9",
    year: "2009",
    country: "South Africa",
    description:
      "An extraterrestrial race forced to live in slum-like conditions on Earth suddenly finds a kindred spirit in a government agent who is exposed to their biotechnology.",
    image: process.env.PUBLIC_URL + "/movies-images/district9-2.jpg",
    alt: "District 9 Poster",
    imdb: "https://www.imdb.com/title/tt1136608/",
  },
  {
    title: "Fantastic Mr. Fox",
    year: "2009",
    country: "United States",
    description:
      "An urbane fox cannot resist returning to his farm raiding ways and then must help his community survive the farmers' retaliation.",
    image: process.env.PUBLIC_URL + "/movies-images/Fantastic-Mr-Fox-1.webp",
    alt: "Fantastic Mr. Fox Poster",
    imdb: "https://www.imdb.com/title/tt0432283/",
  },
  {
    title: "Watchmen",
    year: "2009",
    country: "United States",
    description:
      "In an alternate 1985 America in which costumed superheroes are part of the fabric of everyday society, an investigation of the murder of a government-sponsored superhero provokes a crisis.",
    image: process.env.PUBLIC_URL + "/movies-images/watchmen-1.jpg",
    alt: "Watchmen Poster",
    imdb: "https://www.imdb.com/title/tt0409459/",
  },
  {
    title: "Scott Pilgrim vs. The World",
    year: "2010",
    country: "United States",
    description:
      "Scott Pilgrim must defeat his new girlfriend's seven evil exes in order to date her.",
    image:
      process.env.PUBLIC_URL + "/movies-images/Scott-Pilgrim-vs-The-World.jpg",
    alt: "Scott Pilgrim vs. The World Poster",
    imdb: "https://www.imdb.com/title/tt0446029/",
  },
  {
    title: "A Separation",
    year: "2011",
    country: "Iran",
    description:
      "A married couple are faced with a difficult decision - to improve the life of their child by moving to another country or to stay in Iran and look after a deteriorating parent who has Alzheimer's disease.",
    image: process.env.PUBLIC_URL + "/movies-images/a-separation-1.jpg",
    alt: "A Separation Poster",
    imdb: "https://www.imdb.com/title/tt1832382/",
  },
  {
    title: "The Girl with the Dragon Tattoo",
    year: "2011",
    country: "United States",
    description:
      "Journalist Mikael Blomkvist is aided in his search for a woman who has been missing for forty years by Lisbeth Salander, a young computer hacker.",
    image:
      process.env.PUBLIC_URL +
      "/movies-images/the-girl-with-the-dragon-tattoo-1.jpg",
    alt: "The Girl with the Dragon Tattoo Poster",
    imdb: "https://www.imdb.com/title/tt1568346/",
  },
  {
    title: "Detachment",
    year: "2011",
    country: "United States",
    description:
      "A substitute teacher who drifts from classroom to classroom finds a connection to students and teachers alike, while struggling with his own troubled past.",
    image: process.env.PUBLIC_URL + "/movies-images/detachment-1.jpg",
    alt: "Detachment Poster",
    imdb: "https://www.imdb.com/title/tt1683526/",
  },
  {
    title: "Rango",
    year: "2011",
    country: "United States",
    description:
      "A chameleon who has lived as a sheltered family pet finds himself in the grip of an identity crisis. Rango ends up in the town of Dirt, a lawless outpost in the Wild West in desperate need of a new sheriff.",
    image: process.env.PUBLIC_URL + "/movies-images/rango-1.jpg",
    alt: "Rango Poster",
    imdb: "https://www.imdb.com/title/tt1192628/",
  },
  {
    title: "The Cabin in the Woods",
    year: "2012",
    country: "United States",
    description:
      "Five friends go for a break at a remote cabin, where they get more than they bargained for, discovering the truth behind the cabin in the woods.",
    image:
      process.env.PUBLIC_URL + "/movies-images/The-Cabin-in-the-Woods-1.jpg",
    alt: "The Cabin in the Woods Poster",
    imdb: "https://www.imdb.com/title/tt1259521/",
  },
  {
    title: "Begin Again",
    year: "2013",
    country: "United States",
    description:
      "A chance encounter between a disgraced music-business executive and a young singer-songwriter leads to a mutually transformative collaboration in New York City.",
    image: process.env.PUBLIC_URL + "/movies-images/begin-again-1.jpeg",
    alt: "Begin Again Poster",
    imdb: "https://www.imdb.com/title/tt1980929/",
  },
  {
    title: "The Secret Life of Walter Mitty",
    year: "2013",
    country: "United States",
    description:
      "A daydreamer escapes his mundane life through vivid fantasies, embarking on a real-life global adventure that surpasses his wildest imagination.",
    image:
      process.env.PUBLIC_URL +
      "/movies-images/the-secret-life-of-walter-mitty-1.jpg",
    alt: "The Secret Life of Walter Mitty Poster",
    imdb: "https://www.imdb.com/title/tt0359950/",
  },
  {
    title: "Nightcrawler",
    year: "2014",
    country: "United States",
    description:
      "When Louis Bloom, a con man desperate for work, muscles into the world of L.A. crime journalism, he blurs the line between observer and participant to become the star of his own story.",
    image: process.env.PUBLIC_URL + "/movies-images/nightcrawler-3.webp",
    alt: "Nightcrawler Poster 3",
    imdb: "https://www.imdb.com/title/tt2872718/",
  },
  {
    title: "Gone Girl",
    year: "2014",
    country: "United States",
    description:
      "With his wife's disappearance having become the focus of an intense media circus, a man sees the spotlight turned on him when it's suspected that he may not be innocent.",
    image: process.env.PUBLIC_URL + "/movies-images/gone-girl-1.jpg",
    alt: "Gone Girl Poster",
    imdb: "https://www.imdb.com/title/tt2267998/",
  },
  {
    title: "Scarlet Innocence",
    year: "2014",
    country: "South Korea",
    description:
      "A modern-day retelling of a classic Korean folktale, following a university professor whose affair with a young woman leads to a spiral of obsession, betrayal, and revenge.",
    image: process.env.PUBLIC_URL + "/movies-images/scarlet-innocence-2.jpg",
    alt: "Scarlet Innocence Poster",
    imdb: "https://www.imdb.com/title/tt4065322/",
  },
  {
    title: "The Purge: Anarchy",
    year: "2014",
    country: "United States",
    description:
      "In the second installment of the Purge series, a group of strangers must band together to survive the lawless chaos of Purge Night in Los Angeles, where all crime is legal for 12 hours.",
    image: process.env.PUBLIC_URL + "/movies-images/Purge-Anarchy-01.jpg",
    alt: "The Purge: Anarchy Poster",
    imdb: "https://www.imdb.com/title/tt2975578/",
  },
  {
    title: "Irrational Man",
    year: "2015",
    country: "United States",
    description:
      "A tormented philosophy professor finds a will to live when he commits an existential act.",
    image: process.env.PUBLIC_URL + "/movies-images/irrational-man-1.webp",
    alt: "Irrational Man Poster",
    imdb: "https://www.imdb.com/title/tt3715320/",
  },
  {
    title: "Room",
    year: "2015",
    country: "Ireland, Canada",
    description:
      "A mother and her child are held captive in a small shed, and their bond and resilience become their survival strategy as they plan their escape.",
    image: process.env.PUBLIC_URL + "/movies-images/room-2.jpg",
    alt: "Room Poster",
    imdb: "https://www.imdb.com/title/tt3170832/",
  },
  {
    title: "The Handmaiden",
    year: "2016",
    country: "South Korea",
    description:
      "In 1930s Korea, a con man hires a pickpocket to become the handmaiden to a Japanese heiress as part of an elaborate plot, but unexpected emotions and twists complicate their scheme.",
    image: process.env.PUBLIC_URL + "/movies-images/The-Handmaiden-1.webp",
    alt: "The Handmaiden Poster",
    imdb: "https://www.imdb.com/title/tt4016934/",
  },
  {
    title: "Batman v Superman: Dawn of Justice (Ultimate Edition)",
    year: "2016",
    country: "United States",
    description:
      "Fearing that the actions of Superman are left unchecked, Batman takes on the Man of Steel, while the world wrestles with what kind of a hero it really needs.",
    image:
      process.env.PUBLIC_URL +
      "/movies-images/batman-vs-superman-snyder-cut-5.jpg",
    alt: "Batman v Superman Ultimate Edition Poster 3",
    imdb: "https://www.imdb.com/title/tt2975590/",
  },
  {
    title: "A Silent Voice: The Movie",
    year: "2016",
    country: "Japan",
    description:
      "A young man is ostracized by his classmates after he bullies a deaf girl to the point where she moves away. Years later, he sets out to make amends.",
    image: process.env.PUBLIC_URL + "/movies-images/A-Silent-Voice-2.jpg",
    alt: "A Silent Voice: The Movie Poster",
    imdb: "https://www.imdb.com/title/tt5323662/",
  },
  {
    title: "Your Name",
    year: "2016",
    country: "Japan",
    description:
      "Two teenagers share a profound, magical connection upon discovering they are swapping bodies. When a disaster threatens their town, they must find a way to meet and save each other.",
    image: process.env.PUBLIC_URL + "/movies-images/your-name-1.jpg",
    alt: "Your Name Poster",
    imdb: "https://www.imdb.com/title/tt5311514/",
  },
  {
    title: "American Assassin",
    year: "2017",
    country: "United States",
    description:
      "After the death of his girlfriend at the hands of terrorists, Mitch Rapp is drawn into the world of counterterrorism and vengeance.",
    image: process.env.PUBLIC_URL + "/movies-images/american-assassin-1.jpg",
    alt: "American Assassin Poster",
    imdb: "https://www.imdb.com/title/tt1961175/",
  },
  {
    title: "Blade Runner 2049",
    year: "2017",
    country: "United States",
    description:
      "Young Blade Runner K's discovery of a long-buried secret leads him on a quest to track down former Blade Runner Rick Deckard, who has been missing for thirty years.",
    image: process.env.PUBLIC_URL + "/movies-images/Blade-Runner-2049-1.jpg",
    alt: "Blade Runner 2049 Poster",
    imdb: "https://www.imdb.com/title/tt1856101/",
  },
  {
    title: "Burning",
    year: "2018",
    country: "South Korea",
    description:
      "Jong-su, a deliveryman, runs into Hae-mi, a girl who once lived in his neighborhood, and she asks him to watch her cat while she's away. When she returns, she introduces him to Ben, a mysterious man with a strange hobby.",
    image: process.env.PUBLIC_URL + "/movies-images/Burning-1.jpg",
    alt: "Burning Poster",
    imdb: "https://www.imdb.com/title/tt7282468/",
  },
  {
    title: "Instant Family",
    year: "2018",
    country: "United States",
    description:
      "A couple finds themselves in over their heads when they foster three children, leading to a heartwarming and comedic journey as they navigate the challenges and joys of becoming an instant family.",
    image: process.env.PUBLIC_URL + "/movies-images/Instant-Family-1.jpg",
    alt: "Instant Family Poster",
    imdb: "https://www.imdb.com/title/tt7401588/",
  },
  {
    title: "Penguin Highway",
    year: "2018",
    country: "Japan",
    description:
      "Aoyama, a curious fourth-grader, investigates the mysterious appearance of penguins in his town, leading him on a whimsical and profound adventure that blurs the line between childhood wonder and scientific discovery.",
    image: process.env.PUBLIC_URL + "/movies-images/penguin-highway-1.jpg",
    alt: "Penguin Highway Poster",
    imdb: "https://www.imdb.com/title/tt8076344/",
  },
  {
    title: "Violet Evergarden",
    year: "2018",
    country: "Japan",
    description:
      "After the war, a former soldier named Violet Evergarden embarks on a journey of self-discovery as she becomes an Auto Memory Doll, helping others express their deepest emotions through letters.",
    image: process.env.PUBLIC_URL + "/movies-images/Violet-Evergarden-1.jpg",
    alt: "Violet Evergarden Poster",
    imdb: "https://www.imdb.com/title/tt7078180/",
  },
  {
    title: "The Platform",
    year: "2019",
    country: "Spain",
    description:
      "In a mysterious vertical prison, inmates are fed via a platform that descends floor by floor, leading to a brutal struggle for survival and a chilling commentary on social inequality.",
    image: process.env.PUBLIC_URL + "/movies-images/the-platform-1.jpg",
    alt: "The Platform Poster",
    imdb: "https://www.imdb.com/title/tt8228288/",
  },
  {
    title: "Everything Everywhere All at Once",
    year: "2022",
    country: "United States",
    description:
      "An aging Chinese immigrant is swept up in an interdimensional adventure, where she must save the world by exploring other universes connecting with the lives she could have led.",
    image:
      process.env.PUBLIC_URL +
      "/movies-images/everything-everywhere-all-at-once-2.webp",
    alt: "Everything Everywhere All at Once Poster 2",
    imdb: "https://www.imdb.com/title/tt6710474/",
  },
  {
    title: "The Batman",
    year: "2022",
    country: "United States",
    description:
      "When a sadistic serial killer begins murdering key political figures in Gotham, Batman is forced to investigate the city's hidden corruption and question his family's involvement.",
    image: process.env.PUBLIC_URL + "/movies-images/the-batman-2.webp",
    alt: "The Batman Poster 2",
    imdb: "https://www.imdb.com/title/tt1877830/",
  },
  {
    title: "Spider-Man: Across the Spider-Verse",
    year: "2023",
    country: "United States",
    description:
      "Miles Morales catapults across the Multiverse, where he encounters a team of Spider-People charged with protecting its very existence.",
    image:
      process.env.PUBLIC_URL +
      "/movies-images/Spider-Man-Across-the-Spider-Verse-1.webp",
    alt: "Spider-Man: Across the Spider-Verse Poster",
    imdb: "https://www.imdb.com/title/tt9362722/",
  },
  {
    title: "Magazine Dreams",
    year: "2023",
    country: "United States",
    description:
      "A troubled amateur bodybuilder struggles to find human connection as he battles his own demons and obsessions in pursuit of fame.",
    image: process.env.PUBLIC_URL + "/movies-images/magazine-dreams-1.jpg",
    alt: "Magazine Dreams Poster",
    imdb: "https://www.imdb.com/title/tt13652142/",
  },
  {
    title: "Sinners",
    year: "2025",
    country: "United States",
    description:
      "Details forthcoming. 'Sinners' is an upcoming film slated for release in 2025.",
    image: process.env.PUBLIC_URL + "/movies-images/sinners-1.webp",
    alt: "Sinners Poster",
    imdb: "https://www.imdb.com/title/tt31193180/",
  },
];

const MoviesYearGraph = ({ movies, selectedYear, onYearClick }) => {
  let minYear = parseInt(movies[0].year, 10);
  if (minYear % 5 !== 0) minYear -= minYear % 5;

  let maxYear = parseInt(movies[movies.length - 1].year, 10);
  if (maxYear % 5 !== 0) maxYear += 5 - (maxYear % 5);

  const yearCounts = {};
  movies.forEach((movie) => {
    const year = parseInt(movie.year, 10);
    if (year >= minYear && year <= maxYear) {
      yearCounts[year] = (yearCounts[year] || 0) + 1;
    }
  });

  const years = [];
  for (let y = minYear; y <= maxYear; y++) {
    years.push({ year: y, count: yearCounts[y] || 0 });
  }

  const maxCount = Math.max(...years.map((y) => y.count));
  const barWidth = 13.5;
  const barGap = 2;
  const svgHeight = 140;
  const chartHeight = 80;
  const labelHeight = 35;
  const svgWidth = years.length * (barWidth + barGap);

  // Inline styles for horizontal scroll
  const scrollContainerStyle = {
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    margin: "0 -12px",
    padding: "0 12px",
    maxWidth: "100%",
  };

  // Hide scrollbar on mobile (optional, can be removed if undesired)
  const hideScrollbarStyle = {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  };

  return (
    <div
      style={{
        marginBottom: 24,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          ...scrollContainerStyle,
          ...hideScrollbarStyle,
        }}
        className="movies-year-graph-scroll"
      >
        <svg
          width={svgWidth}
          height={svgHeight}
          style={{ minWidth: "100%", display: "block" }}
        >
          {years.map((y, idx) => {
            const barHeight = maxCount ? (y.count / maxCount) * chartHeight : 0;
            const isSelected = selectedYear === y.year;
            return (
              <g
                key={y.year}
                onClick={() => onYearClick(y.year)}
                style={{ cursor: "pointer" }}
              >
                <rect
                  x={idx * (barWidth + barGap)}
                  y={svgHeight - barHeight - labelHeight}
                  width={barWidth}
                  height={barHeight}
                  fill={isSelected ? "#f8f8f8" : "#a0a0a0"}
                  rx={6}
                  ry={6}
                  style={{
                    opacity: y.count > 0 ? 1 : 0.25,
                    transition: "fill 0.2s, opacity 0.2s",
                  }}
                />
                {/* Count label above bar (only if count > 0) */}
                {/* {y.count > 0 && (
                  <text
                    x={idx * (barWidth + barGap) + barWidth / 2}
                    y={svgHeight - barHeight - labelHeight - 6}
                    fontSize="11"
                    fill="#f8f8f8"
                    textAnchor="middle"
                    style={{
                      fontWeight: 500,
                      textShadow: "0 1px 2px #2228",
                    }}
                  >
                    {y.count}
                  </text>
                )} */}
                {/* Year labels (every 5 years, always show first and last) */}
                {((y.year - minYear) % 5 === 0 ||
                  idx === 0 ||
                  idx === years.length - 1) && (
                  <text
                    x={
                      idx === 0
                        ? idx * (barWidth + barGap) + barWidth / 2 + 4 // shift right for first label
                        : idx === years.length - 1
                        ? idx * (barWidth + barGap) + barWidth / 2 - 4 // shift left for last label
                        : idx * (barWidth + barGap) + barWidth / 2
                    }
                    y={svgHeight - 8}
                    fontSize="12"
                    fill={"#a0a0a0"}
                    textAnchor="middle"
                    style={{
                      fontWeight: 400,
                      pointerEvents: "none",
                    }}
                  >
                    {y.year}
                  </text>
                )}
              </g>
            );
          })}
        </svg>
      </div>
    </div>
  );
};

// Helper to get year from URL (query param)
function getYearFromUrl() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const year = params.get("year");
  if (year && /^\d{4}$/.test(year)) {
    return parseInt(year, 10);
  }
  return null;
}

// Helper to set year in URL (query param)
function setYearInUrl(year) {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  if (year) {
    params.set("year", year);
  } else {
    params.delete("year");
  }
  const newUrl =
    window.location.pathname +
    (params.toString() ? `?${params.toString()}` : "") +
    window.location.hash;
  window.history.replaceState({}, "", newUrl);
}

const Movies = () => {
  const [selectedYear, setSelectedYear] = useState(() => getYearFromUrl());

  // Update URL when selectedYear changes
  useEffect(() => {
    setYearInUrl(selectedYear);
  }, [selectedYear]);

  // Listen to popstate (back/forward navigation) to update selectedYear from URL
  useEffect(() => {
    const onPopState = () => {
      setSelectedYear(getYearFromUrl());
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  const handleCardClick = (imdbUrl) => {
    window.open(imdbUrl, "_blank", "noopener,noreferrer");
  };

  const handleYearClick = useCallback(
    (year) => {
      setSelectedYear(year === selectedYear ? null : year);
    },
    [selectedYear]
  );

  const filteredMovies = selectedYear
    ? movies.filter((m) => parseInt(m.year, 10) === selectedYear)
    : movies;

  // If less than 3, add 2 empty so UI doesn't break
  let displayMovies = filteredMovies;
  if (filteredMovies.length < 3) {
    const emptyCount = 3 - filteredMovies.length;
    displayMovies = [
      ...filteredMovies,
      ...Array(emptyCount)
        .fill(null)
        .map((_, i) => ({ __empty: true, key: `empty-${i}` })),
    ];
  }

  return (
    <div className="container">
      <h1 className="subtitle">My Favorite Movies</h1>
      <MoviesYearGraph
        movies={movies}
        selectedYear={selectedYear}
        onYearClick={handleYearClick}
      />
      <div className="movies-container">
        {displayMovies.map((movie, idx) =>
          movie && !movie.__empty ? (
            <div
              key={idx}
              className="movie-card"
              style={{ cursor: "pointer" }}
              onClick={() => handleCardClick(movie.imdb)}
              tabIndex={0}
              role="button"
              aria-label={`Open IMDb page for ${movie.title}`}
            >
              <img
                src={movie.image}
                alt={movie.alt}
                className="movie-poster"
                loading="lazy"
              />
              <div className="movie-overlay">
                <span className="movie-year">{movie.year}</span>
                <span className="movie-country">{movie.country}</span>
                <h3 className="movie-title">{movie.title}</h3>
                <div className="movie-description-hover">
                  {movie.description}
                </div>
              </div>
            </div>
          ) : (
            <div
              key={movie ? movie.key : `empty-${idx}`}
              className="movie-card"
              style={{
                background: "transparent",
                boxShadow: "none",
                border: "none",
                cursor: "default",
                pointerEvents: "none",
                visibility: "hidden",
              }}
              aria-hidden="true"
              tabIndex={-1}
            />
          )
        )}
      </div>
    </div>
  );
};

export default Movies;
